__turbopack_context__.v({
  "listItem": "ArticleSectionTags-module-scss-module__mNBzQa__listItem",
  "tagLink": "ArticleSectionTags-module-scss-module__mNBzQa__tagLink",
  "tags": "ArticleSectionTags-module-scss-module__mNBzQa__tags",
});
